import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '~/routes/components/AuthProvider';
import TableComponent from '~/components/TableComponent';
import Layout from '~/components/Layout';
interface TradingActivitiesProps {
  tradingActivities: any,
  onChange: (data: any) => void,
  isFetchingData: boolean,
  tradingOptions: any[]
  dataFilterActivities: any
}

const defaultFilter = {
  page: 0,
  status: 'completed',
  rows: 10
}

const TradingActivities: React.FC<TradingActivitiesProps> = (props) => {
  const [tradingActivities, setTradingActivities] = useState(null)
  const { t } = useTranslation()
  const [dataFiltered, setDataFiltered] = useState(defaultFilter)
  const { systemData: { amountUnit } } = useAuth()

  const tableColumnHeaders = [
    {
      name: t('Procurement month'),
      key: 'date',
      type: 'dateRibbon',
      format: 'MMM YYYY'
    },
    {
      name: t('BLE price (€/100kg) [original Price]'),
      key: 'price',
      type: 'ble-price-change',
      info: t('If the BLE price increases as part of the hedging transaction in favor of the suppliers, this will also be confirmed. The original price is shown in square brackets for clarity.')
    },
    {
      name: t('Offered amount (in {{amountUnit}})', { amountUnit }),
      key: 'amount',
      type: 'number'
    },
    {
      name: t('Hedging amount (in {{amountUnit}})', { amountUnit }),
      key: 'confirmedAmount',
      info: t('The amount your dairy has already confirmed for the respective trading month.'),
      type: 'number'
    },
    {
      name: t('Offer date'),
      type: 'date',
      info: t('Date and time when you have submitted your offered amount within the trading slot.'),
      key: 'createdAt',
      format: 'DD.MM.YYYY HH:mm'
    },
    {
      name: t('Confirmation date'),
      type: 'date',
      info: t('Date and time when your dairy has accepted your offered amount totally, partially or not at all within the trading slot (fixed price volume).'),
      key: 'confirmationDate',
      format: 'DD.MM.YYYY HH:mm'
    },
    {
      name: t('Trading slot ID'),
      key: 'tradingSlotUniqueId'
    }
  ]

  useEffect(() => {
    if (JSON.stringify(dataFiltered) !== JSON.stringify(props.dataFilterActivities)) {
      props.onChange(dataFiltered)
    }
  }, [dataFiltered])

  useEffect(() => {
    if (props.tradingActivities) {
      setTradingActivities(props.tradingActivities)
    }
  }, [props.tradingActivities])

  function renderContent() {
    return <TableComponent
      isFetchingData={props.isFetchingData}
      animated
      tableColumnHeaders={tableColumnHeaders}
      dataFiltered={dataFiltered}
      rows={rows}
      total={filtered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
    />
  }

  function renderTradingActivities() {
    return renderContent()
  }

  const { filtered, rows } = tradingActivities ? tradingActivities : { filtered: 0, rows: [] }

  return <Layout
    title={t('Trading activities')}
    fontSizeHeader={'18px'}
    childContainerSize={'auto'}
  >
    {tradingActivities && <div>
      {renderTradingActivities()}
    </div>}
  </Layout>
}
export default TradingActivities
